export const SHOPIFY_STORES_SLICE_NAME = '@@shopifyStores';
